var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1,106.7C31.9,106.7,0,138.6,0,177.8v71.1c0,9.8,8.2,17.4,17.4,20.7,20.9,7.2,35.9,27.1,35.9,50.4s-15,43.2-35.9,50.4c-9.2,3.2-17.4,10.9-17.4,20.7v71.1c0,39.2,31.9,71.1,71.1,71.1h497.8c39.2,0,71.1-31.9,71.1-71.1v-71.1c0-9.8-8.2-17.4-17.4-20.7-20.9-7.2-35.9-27.1-35.9-50.4s15-43.2,35.9-50.4c9.2-3.2,17.4-10.9,17.4-20.7v-71.1c0-39.2-31.9-71.1-71.1-71.1H71.1ZM462.2,408.9v-177.8H177.8v177.8h284.4ZM124.4,213.3c0-19.7,15.9-35.6,35.6-35.6h320c19.7,0,35.6,15.9,35.6,35.6v213.3c0,19.7-15.9,35.6-35.6,35.6H160c-19.7,0-35.6-15.9-35.6-35.6v-213.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.61ca7ff1a9e65e0aa6669ba7ad940adb.svg";
export { ForwardRef as ReactComponent };